import TemplateView from '../../TemplateView'
import ResizableInput from '../ResizableInput'
import {isCtrlPressed, isEnter, isShiftPressed} from '../../keyHandlers'
import messageResource from '../../messageResource'
import {NUMBER_ALLOWED_CHARACTERS} from './constants'
import {validateCommentText} from './utils'

export default class CommentInput extends TemplateView {
    constructor({
        onShowInputChanged = () => {},
        onTextChange = () => {},
        onCommentAdded = () => {},
        refreshScrollCb = () => {},
    }) {
        super()

        this.callbacks = {
            onShowInputChanged,
            onTextChange,
            onCommentAdded,
            refreshScrollCb,
        }

        this.state = {
            showInput: false,
            text: '',
            preventBlur: false,
        }

        this.onStatePropertyChanged('showInput', showInput => {
            this.input.toggle(showInput)
            this.getEl().toggleClass('inEdit', this.state.showInput)

            if (showInput) {
                this.input.focus()
            } else {
                this.input.setState({text : ""})
            }
        })

        this.onStatePropertyChanged('text', text => {
            this.input.setState({text})
            this._updateBottomLine()
        })
    }

    templateHtml() {
        return "<div class='components_commentInput'>" +
               "    <div class='inputArea'/>" +
               "    <div class='sendCommentLine'>" +
               "        <div class='bottomLineText'>" +
               "            <span class='placeholderText'><%=placeholderText%></span>" +
               "            <span class='errorText'></span>" +
               "        </div>" +
               "        <div class='sendCommentButton'>" +
               "            <div class='commentLabel'><%=comment%></div>" +
               "            <div class='sendIcon'/>" +
               "        </div>" +
               "    </div>" +
               "</div>"
    }

    messageKeys() {
        return {
            placeholderText: 'panel.common.comments.comment_input.placeholder',
            comment: 'panel.common.comments.comment_input.comment_label',
        }
    }

    afterRender() {
        this.input = new ResizableInput({
            showCounter: false,
            heightLimit: 300,
            minHeight: 75,
            maxLength: NUMBER_ALLOWED_CHARACTERS,
            allowInputOverMaxLength: true,
            onFocus: () => {
                this.callbacks.refreshScrollCb()
            },
            onBlur: (text) => {
                if (text === '' && !this.state.preventBlur) {
                    this.callbacks.onShowInputChanged(false)
                    this.callbacks.refreshScrollCb()
                }
            },
            onResize: () => this.callbacks.refreshScrollCb(),
            onKeyDown: (e) => this._handleKeyDown(e),
            onChange: this.callbacks.onTextChange,
        }).init(this.find('.inputArea'))

        this.input.hide()

        this.$errorText = this.find('.errorText')
        this.$sendCommentButton = this.find('.sendCommentButton')
        this.$sendCommentButton.click((e) => {
            e.stopPropagation()
            this._handleSendClick()
        })

        this.find('.sendCommentLine').click(() => {
            if (!this.state.showInput) {
                this.callbacks.onShowInputChanged(true)
            }
            this.input.focus()
        })

        this._subscribeToPreventOnInputBlurEventOnBottomLineClick()
        this.renderInitialState()
    }

    _updateBottomLine() {
        const characterCount = this.state.text.length
        const allowSend = validateCommentText(this.state.text)
        this.$sendCommentButton.toggleClass('active', allowSend && this.state.showInput)
        this.$errorText.toggle(characterCount > NUMBER_ALLOWED_CHARACTERS)

        if (characterCount > NUMBER_ALLOWED_CHARACTERS) {
            const exceededCharacters = characterCount - NUMBER_ALLOWED_CHARACTERS
            this.$errorText.text(
                messageResource.getMessage('panel.common.comments.number_characters_exceeded', [NUMBER_ALLOWED_CHARACTERS, exceededCharacters]))
        }
    }

    _handleSendClick() {
        if (this.state.text !== '' && this.state.text.length <= NUMBER_ALLOWED_CHARACTERS) {
            this.callbacks.onCommentAdded(this.state.text)
            this.callbacks.refreshScrollCb()
        }
    }

    _handleKeyDown(e) {
        if (isEnter(e.keyCode) && (isCtrlPressed(e) || isShiftPressed(e))) {
            this._handleSendClick()
        }
    }

    _subscribeToPreventOnInputBlurEventOnBottomLineClick() {
        this.find('.sendCommentLine')
            .on('mousedown', () => this.setStateInternal({preventBlur: true}))
            .on('mouseup', () => this.setStateInternal({preventBlur: false}))
    }
}


// WEBPACK FOOTER //
// ./web/js/panels/comments/CommentInput.js